module.exports = __webpack_public_path__ + "static/media/node.8f85d265.svg";